import BasicRoute from "components/routes/BasicRoute";
import AssistenteAgendamentoReunioes from "entity/Reuniao/components/AssistenteAgendamentoReunioes";
import NovoAssistenteAgendamento from "entity/Reuniao/components/NovoAssistenteAgendamento";
import ReuniaoConsulta from "entity/Reuniao/components/ReuniaoConsulta";
import ReuniaoForm from "entity/Reuniao/components/ReuniaoForm";

export default function RoutesMenusProduto() {
    return <>
        <BasicRoute
            uid='reuniaoConsult'
            route="consultareuniao"
            // menuProps={{
            //     text: "Reuniões",
            //     sequence: "000001",
            //     iconName: "Groups",
            // }}
            element={<ReuniaoConsulta />}
        />
        <BasicRoute
            uid='reuniaoForm'
            route="reuniao"
            // menuProps={{
            //     text: "Nova Reunião",
            //     iconName: "GroupAdd",
            //     sequence: "000000",
            // }}
            element={<ReuniaoForm />}
        />
        <BasicRoute
            uid='assistenteReuniao'
            route="assistente-reuniao"
            // menuProps={{
            //     text: "Assistente de Reuniões",
            //     iconName: "Event",
            //     sequence: "000000",
            // }}
            element={<AssistenteAgendamentoReunioes />}
        />

        <BasicRoute
            uid='assistenteReuniao2'
            route="assistente-reuniao2"

            element={<NovoAssistenteAgendamento />}
        />


    </>;
}